export default (amount) => {
  if (!amount) {
    amount = '0.00%';
  }
  return parseFloat(amount).toFixed(2) + '%';
};
